// The column a phone reader last looked at, remembered across visits.
// Best-effort like the other stored preferences: private mode, blocked site
// data and quota errors all make storage throw, and none of them may break
// the board.

export const LAST_COLUMN_KEY = 'irm.board.lastColumn';

export function readLastColumn(
    storage: Pick<Storage, 'getItem'> | undefined
): string | null {
    try {
        return storage?.getItem(LAST_COLUMN_KEY) || null;
    } catch {
        return null;
    }
}

export function writeLastColumn(
    storage: Pick<Storage, 'setItem'> | undefined,
    id: string
): void {
    try {
        storage?.setItem(LAST_COLUMN_KEY, id);
    } catch {
        /* the board works without it */
    }
}
